import { render, staticRenderFns } from "./buyDomain.vue?vue&type=template&id=b2269cb6"
import script from "./buyDomain.vue?vue&type=script&lang=js"
export * from "./buyDomain.vue?vue&type=script&lang=js"
import style0 from "./buyDomain.vue?vue&type=style&index=0&id=b2269cb6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports